import Link from 'next/link';
import { useTranslations } from 'next-intl';

import { logo as IconLogo } from '@/components/icons/logo';
import { FEATURES } from '@/constants';

import ChainlinkBanner from './ChainlinkBanner';
import { infoData, sidebarData } from './data';
import StatusBox from './StatusBox/StatusBox';
import SidebarItem from './sidebar-item';

const Sidebar = () => {
  const t = useTranslations('layout.externalLinks');

  return (
    <aside className="fixed top-0 left-0 h-full w-[264px] hidden lg:flex flex-col border-r-2 border-border-primary bg-gray-700 z-40">
      <div className="flex flex-1 flex-col  justify-between gap-4 px-8 pt-9 pb-4">
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-6">
            <IconLogo />
            <StatusBox />
          </div>
          <nav className="flex flex-col">
            {sidebarData.map((sidebarItem) => (
              <SidebarItem key={sidebarItem.href} {...sidebarItem} />
            ))}
          </nav>
        </div>
        {FEATURES.chainlinkBanner && <ChainlinkBanner />}
      </div>
      <div className="flex items-center justify-between px-8 py-5 border-t-2 border-border-primary">
        {infoData.map((info) => (
          <Link
            href={info.href}
            target="_blank"
            id={info.name}
            key={info.href}
            aria-label={info.labelKey ? t(info.labelKey) : info.name}
            className="p-2 bg-button-secondary hover:bg-button-secondary-hover active:bg-button-secondary-pressed rounded-10 transition-colors text-text-primary hover:text-highlight"
          >
            {info.icon}
          </Link>
        ))}
      </div>
    </aside>
  );
};

export default Sidebar;
